import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getSeoForPath, SITE_URL } from '../seoConfig';

const upsertMeta = (selector, attribute, value, content) => {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, value);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
};

const upsertCanonical = (href) => {
  let element = document.head.querySelector('link[rel="canonical"]');
  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', 'canonical');
    document.head.appendChild(element);
  }
  element.setAttribute('href', href);
};

export default function Seo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const page = getSeoForPath(pathname);
    const canonical = new URL(pathname === '/' ? '/' : pathname, SITE_URL).toString();

    document.title = page.title;
    document.documentElement.lang = 'fr';
    upsertCanonical(canonical);
    upsertMeta('meta[name="description"]', 'name', 'description', page.description);
    upsertMeta('meta[name="robots"]', 'name', 'robots', page.index ? 'index,follow' : 'noindex,nofollow');
    upsertMeta('meta[property="og:title"]', 'property', 'og:title', page.title);
    upsertMeta('meta[property="og:description"]', 'property', 'og:description', page.description);
    upsertMeta('meta[property="og:url"]', 'property', 'og:url', canonical);
    upsertMeta('meta[property="og:type"]', 'property', 'og:type', 'website');
    upsertMeta('meta[property="og:locale"]', 'property', 'og:locale', 'fr_CA');
    upsertMeta('meta[name="twitter:card"]', 'name', 'twitter:card', 'summary_large_image');
  }, [pathname]);

  return null;
}
